import React, { memo, useMemo } from "react";

import { useBottomMenu } from "../../hooks/useBottomMenu";
import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";

import { CommandHistory } from "../command-history";
import { FloatingMenu } from "../floating-menu";
import { PreviewButton } from "../preview-button";

import { useDashboardContext } from "../../contexts/dashboard-context";
import { useDefinition } from "../../hooks/useDefinition";
import { useIsTransformMode } from "../../hooks/useIsTransformMode";
import { CloneButton } from "../clone-button";
import { EventsButton } from "../events-button";
import { TopToolbar } from "./top-toolbar";
import { SpreadOverviewButton } from "../spread-overview/spread-overview-button";

export const TopToolbarContainer = memo(function TopToolbarContainer() {
	const dashboard = useDashboardContext();
	const { stack } = useBottomMenu();
	const isEditingText = !!stack.find((i) => i.id === "text-value");

	const definition = useDefinition();

	const [isTransformMode] = useIsTransformMode();
	const [isPreviewMode] = useIsPreviewMode();

	const enableCopySpreads = definition?.product?.copySpreads;
	const enableCalendarEvents = dashboard.canChangeCalendarEvents();

	const enableSpreadOverview = definition?.canManipulateSpreads();

	const right = useMemo(() => {
		return (
			<>
				{enableCalendarEvents && <EventsButton />}
				{enableCopySpreads && <CloneButton />}
				{enableSpreadOverview && <SpreadOverviewButton />}
				<PreviewButton />
				<FloatingMenu />
			</>
		);
	}, [enableCalendarEvents, enableCopySpreads, enableSpreadOverview]);

	// Don't show top toolbar in previewMode or when editing text
	if (isPreviewMode || isEditingText) return null;

	// Empty topbar is rendered as to avoid product "jumping"
	if (isTransformMode) {
		return <TopToolbar left={null} right={null} />;
	}

	return <TopToolbar left={<CommandHistory />} right={right} />;
});
